import React from 'react';
import { ToggleField } from '@/components/ui';
import { cx } from '@/ui/utils/cx';

type Props = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

export default function RecipientEnabledField({ id, checked, onChange, className }: Props) {
  const hint = checked
    ? 'Allow this recipient to receive alerts and messages.'
    : 'Disabled recipients are saved but will not receive alerts.';

  return (
    <ToggleField
      id={id}
      checked={checked}
      onChange={onChange}
      label="Enabled for deliveries"
      hint={hint}
      className={cx('recipient-enabled-field', className)}
    />
  );
}
